export * from "./e-theme-default-en-us-shape-input";
